export default {
    SET_PROJECTS(state, projects) {
        state.projects = projects;
    }
}